export default "__VITE_PUBLIC_ASSET__291c29be__"